/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendSegmentDto } from '../../models/backend-segment-dto';

export interface ProjectsSegmentsList$Params {
  industry?: number;
  name?: string;
  name_en?: string;

  /**
   * A search term.
   */
  search?: string;
}

export function projectsSegmentsList(
  http: HttpClient,
  rootUrl: string,
  params?: ProjectsSegmentsList$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<Array<BackendSegmentDto>>> {
  const rb = new RequestBuilder(rootUrl, projectsSegmentsList.PATH, 'get');
  if (params) {
    rb.query('industry', params.industry, {});
    rb.query('name', params.name, {});
    rb.query('name_en', params.name_en, {});
    rb.query('search', params.search, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<Array<BackendSegmentDto>>;
    }),
  );
}

projectsSegmentsList.PATH = '/api/projects/segments/';
